module.exports = "/assets/review_bad.webp"